import { render, staticRenderFns } from "./AddContactUsItem.vue?vue&type=template&id=f12f8a06&scoped=true&"
import script from "./AddContactUsItem.vue?vue&type=script&lang=js&"
export * from "./AddContactUsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12f8a06",
  null
  
)

export default component.exports